import React from "react";
import {connect} from "react-redux";
import {uploadImage} from "./action";
import {changeName} from "./action";
import EditProfileForm from "./forms/EditProfileForm";

class EditProfilePage extends React.Component{
    state={
        popup1: false,
        popup2: false
    };
    uploadImg=(data)=> {
        this.setState({popup2: false, loading: true});
        this.props.uploadImage(data)
            .then(msg => this.setState({popup2: true, loading: false}))
    };
    
    changeName=(data)=>{this.setState({popup1: false, loading: true});this.props.changeName(data).then(msg => this.setState({popup1: true, loading: false}))};
    render(){
        return(
            <div>

                <h1 className="content_title">Edit Profile</h1>
                {this.state.loading && (
                    <div className="loader">
                        <div></div>
                        <h1>Please Wait...</h1>
                    </div>
                    )}
                {this.props.name && (
                    <EditProfileForm name={this.props.name} uploadImage={this.uploadImg} changeName={this.changeName} gravatarImageURL={this.props.gravatarImageURL}/>  
                )}   
                {this.state.popup1 && (
                <div className="popup">
                    <h1>Thanks! Your Name is Changed</h1>
                </div>)}
                {this.state.popup2 && (
                <div className="popup">
                    <h1>Thanks! Your Gravatar Image is Changed</h1>
                </div>)}
            </div>    
        );
    };
};

function mapStateToProps (state) {
    return {name: state.user.name, gravatarImageURL: state.user.gravatarImage}
}

export default connect(mapStateToProps, {uploadImage, changeName})(EditProfilePage);
